import React from 'react'
import { useIntl, Link } from 'gatsby-plugin-intl'
import Layout from '../../components/Layout/index'
import Header from '../../modules/Header'
import Footer from '../../modules/Footer'
import SEO from '../../components/seo'
import PressRelease from '../../components/PressRelease'
import PressBoilerplate from '../../components/PressRelease/PressBoilerplate'

import messages from '../../messages/pageTitles.lang'
import metaDescription from '../../messages/pageMetaDescriptions.lang'
import Image from '../../images/news/SMM_Peakwork_Pressemeldung_1_1_en.png'
import ImageDE from '../../images/news/SMM_Peakwork_Pressemeldung_1_1_de.png'

import { newsList } from '../../components/NewsPage/data'

const IndexPage = () => {
  const { formatMessage, locale } = useIntl()
  const tsboLink = { tsbo: <Link to="/products/quickstart/">TravelSandbox®</Link> }

  return (
    <Layout footer={<Footer />} header={<Header withTeaser />}>
      <SEO
        title={formatMessage(messages.TitleSmmPeakwork)}
        imageAlt={formatMessage(messages.TitleSmmPeakwork)}
        description={formatMessage(metaDescription.NewsSmmPeakworkDescription)}
        image={locale === 'de' ? ImageDE : Image}
        lang={locale}
      />
      <PressRelease
        article={newsList.smmPeakwork}
        articleLinks={tsboLink}
        addon={
          <PressBoilerplate
            content={newsList.smmPeakwork.about}
            contentLinks={tsboLink}
          />
        }
      />
    </Layout>
  )
}

export default IndexPage
